import axios from "axios";
import { useState } from "react";

export const useLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  async function handleLogin() {
    const user = {
      email,
      password,
      isRememberMe: rememberMe,
    };
    try {
      setLoading(true);
      const response = await axios.post("/api/users/login", user);
      setLoading(false);
      // If server requested OTP verification, redirect to verify-otp
      if (response.data && response.data.otpSent) {
        // store pending login info for verify screen
        sessionStorage.setItem(
          "pendingLogin",
          JSON.stringify({ email, isRememberMe: rememberMe })
        );
        window.location.href = "/verify-otp";
        return;
      }

      // Persist according to Remember Me flag
      const storage = rememberMe ? localStorage : sessionStorage;
      localStorage.setItem("isRememberMe", rememberMe);
      storage.setItem("currentUser", JSON.stringify(response.data));
      window.location.href = "/";
    } catch (error) {
      console.log(error);
      setLoading(false);
      setError(true);
    }
  }

  return {
    email,
    password,
    setEmail,
    setPassword,
    loading,
    error,
    rememberMe,
    setRememberMe,
    handleLogin,
  };
};
